import { render } from "./chat.html?vue&type=template&id=5632b097&scoped=true&lang=html&external"
import script from "./chat.component.vue?vue&type=script&lang=js"
export * from "./chat.component.vue?vue&type=script&lang=js"

import "./_chat.mobile.scss?vue&type=style&index=0&id=5632b097&lang=scss&scoped=true&external"
import "./_chat.desktop.scss?vue&type=style&index=1&id=5632b097&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5632b097"]])

export default __exports__